import React, { useState, useEffect } from 'react';
import { Snackbar, Alert, Chip, Box, Tooltip } from '@mui/material';
import { useAppSelector } from '../redux/redux.hook';
import { 
  CloudOff as CloudOffIcon, 
  CloudDone as CloudDoneIcon,
} from '@mui/icons-material';

export const NetworkStatusIndicator: React.FC = () => {
  const { isOnline } = useAppSelector(state => state.sync);
  const [showSnackbar, setShowSnackbar] = useState(false);
  const [lastStatus, setLastStatus] = useState(isOnline);

  // Show notification when status changes
  useEffect(() => {
    if (isOnline !== lastStatus) {
      setShowSnackbar(true);
      setLastStatus(isOnline);
    }
  }, [isOnline, lastStatus]);

  return (
    <>
      <Box sx={{ display: 'inline-flex', alignItems: 'center' }}>
        <Tooltip title={isOnline ? "Vous êtes  en ligne!" : "Vous êtes hors ligne - Les changements/ajouts peuvent être synchronisés ultérieurement "}>
          <Chip
            size="small"
            icon={isOnline ? <CloudDoneIcon /> : <CloudOffIcon />}
            label={isOnline ? "En ligne" : "Hors ligne"}
            color={isOnline ? "success" : "warning"}
            sx={{ mr: 1 }}
          />
        </Tooltip>
      </Box>

      <Snackbar
        open={showSnackbar}
        autoHideDuration={10000}
        onClose={() => setShowSnackbar(false)}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      >
        <Alert 
          severity={isOnline ? "success" : "warning"} 
          onClose={() => setShowSnackbar(false)}
        >
          {isOnline 
            ? "Vous êtes de retour enligne! Vous pouvez synchroniser vos données." 
            : "Vous êtes hors ligne. Vos changements seront enregistrés localement. Vou pouvez les synchroniser une fois en ligne."}
        </Alert>
      </Snackbar>
    </>
  );
};